var exports = {
  "kL": "xe533113f--4c81dc--container",
  "Ox": "xe533113f--4c81dc--container-m",
  "HV": "xe533113f--4c81dc--container-l",
};

module.exports = exports;
